module.exports = __webpack_public_path__ + "static/Auto-Share-5-e1407759042667-a6ba91d1306542a24f0b5f096e4e44e4.jpg";